import AppointmentModal from "./AppointmentModal";
export default AppointmentModal;